import SectionContainer from '@/components/shared/SectionContainer';
import React from 'react';
import { ProductGridSkeleton } from '../../components/ProductGrid';
import { SkeletonText } from '@skin-seoul/design-system';
const SkinSeoulSelectSectionSkeleton = () => {
  return <SectionContainer containerInnerProps={{
    paddingY: {
      base: 8,
      tablet: 18
    },
    alignItems: 'stretch',
    gap: 12
  }} data-sentry-element="SectionContainer" data-sentry-component="SkinSeoulSelectSectionSkeleton" data-sentry-source-file="SkinSeoulSelectSection.skeleton.tsx">
      <SkeletonText noOfLines={1} h="32px" w="30%" data-sentry-element="SkeletonText" data-sentry-source-file="SkinSeoulSelectSection.skeleton.tsx" />

      <ProductGridSkeleton length={5} data-sentry-element="ProductGridSkeleton" data-sentry-source-file="SkinSeoulSelectSection.skeleton.tsx" />
    </SectionContainer>;
};
export default SkinSeoulSelectSectionSkeleton;